import { StyleSheet, Platform, Dimensions } from 'react-native'

export default StyleSheet.create({
  containerStyle: {
    flexDirection: 'row',
  },
  usageIconViewStyle: colors => ({
    alignSelf: 'flex-start',
    backgroundColor: colors.myPlanIconBackground,
    padding: 7,
    borderRadius: 6.2,
    marginRight: 20,
  }),
  usageDataViewStyle: {
    flexGrow: 1,
    flexDirection: 'column',
    marginTop: 6,
    ...Platform.select({
      web: {
        flexShrink: 1
      },
      default: {}
    })
  },
  usageValuesContainerViewStyle: {
    flexDirection: 'row',
  },
  usageItemLabelViewStyle: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  usageItemLabelTextStyle: {
    fontSize: 16.6,
  },
  usageValuesViewStyle: {
    width: '70%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  usagePercentageTextStyle: theme => ({
    fontSize: 16.6,
    color: theme.colors.sectionItemTextColor,
  }),
  usageValuesTextStyle: colors => ({
    fontSize: 16.6,
    marginRight: 5,
    color: colors.myPlanUsageValues,
  }),
  percentageIndicatorContainerStyle: {
    marginBottom: 22,
  },
  addUsageButtonTextStyle: {
    fontSize: 18.7,
  },
});
